import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React from 'react';
import { Box, Dialog, DialogTitle, DialogActions, DialogContent as MuiDialogContent, IconButton, TextareaAutosize, Grid, Typography, withStyles } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
import { ProfileManager, MailService, Logger } from '@kailona/core';
import { KailonaTextField, KailonaButton } from '@kailona/ui';
import { withNotification } from '../../context/NotificationContext';
var logger = new Logger('main.RequestDataModal');
var DialogContent = withStyles({
  root: {
    height: '100%',
    margin: '0 20px 20px 20px',
    backgroundColor: '#FFFFFF',
    border: '1px solid #EAEAEA',
    borderRadius: '5px',
    paddingBottom: '25px'
  }
})(MuiDialogContent);

var RequestDataModal = /*#__PURE__*/function (_React$Component) {
  _inherits(RequestDataModal, _React$Component);

  var _super = _createSuper(RequestDataModal);

  function RequestDataModal(props) {
    var _this;

    _classCallCheck(this, RequestDataModal);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "sendRequest", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var to, patientId, fromName, body;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              _this.setState({
                loading: true
              });

              to = _this.toEmailRef.current.value;

              if (to) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return", _this.props.showNotification({
                severity: 'error',
                message: t('ehr', 'Unable to send health data request. Please set your email address in user profile settings!')
              }));

            case 5:
              patientId = ProfileManager.activePatientId;
              fromName = ProfileManager.activeProfile.patientFullName;
              body = _this.emailBodyRef.current.value || _this.defaultEmailBody;
              _context.next = 10;
              return _this.mailService.sendRequestData(patientId, fromName, to, body);

            case 10:
              _this.props.onClose();

              _this.props.showNotification({
                severity: 'success',
                message: t('ehr', 'Health data request was successfully sent')
              });

              _context.next = 18;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](0);
              logger.error(_context.t0);

              _this.props.showNotification({
                severity: 'error',
                message: t('ehr', 'Unable to send health data request. Please contact your administrator!')
              });

            case 18:
              _context.prev = 18;

              _this.setState({
                loading: false
              });

              return _context.finish(18);

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 14, 18, 21]]);
    })));

    _this.mailService = new MailService();
    _this.toEmailRef = /*#__PURE__*/React.createRef();
    _this.emailBodyRef = /*#__PURE__*/React.createRef();
    _this.defaultEmailBody = t('ehr', 'I hereby request all data from my last exam to be uploaded to my personal ' + 'health data archive on the Kailona platform. Please comply within the 30 day period as ' + 'required by the Berufsordnung der Ärztekammern, §630g Abs. 2  BGB and Art. 15  Abs. 3 DSGVO.');
    _this.state = {
      loading: false
    };
    return _this;
  }

  _createClass(RequestDataModal, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Dialog, {
        fullWidth: true,
        open: this.props.isOpen
      }, /*#__PURE__*/React.createElement(DialogTitle, null, /*#__PURE__*/React.createElement(Box, {
        display: "flex",
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(Box, {
        flexGrow: 1
      }, t('ehr', 'Request Data')), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(IconButton, {
        onClick: this.props.onClose
      }, /*#__PURE__*/React.createElement(CloseIcon, null))))), /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        direction: "column"
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6
      }, /*#__PURE__*/React.createElement(KailonaTextField, {
        inputRef: this.toEmailRef,
        id: "providerEmail",
        type: "text",
        label: t('ehr', 'Email'),
        style: {
          width: '100%'
        }
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        style: {
          marginTop: '20px'
        }
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        direction: "column"
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "body2"
      }, t('ehr', 'Message to Provider:'))), /*#__PURE__*/React.createElement(Grid, {
        item: true
      }, /*#__PURE__*/React.createElement(TextareaAutosize, {
        ref: this.emailBodyRef,
        rowsMin: 5,
        defaultValue: this.defaultEmailBody,
        style: {
          width: '100%',
          resize: 'vertical'
        }
      })))))), /*#__PURE__*/React.createElement(DialogActions, null, /*#__PURE__*/React.createElement(KailonaButton, {
        class: "default",
        title: t('ehr', 'Cancel'),
        onClick: this.props.onClose,
        disabled: this.state.loading
      }), /*#__PURE__*/React.createElement(KailonaButton, {
        class: "primary",
        title: t('ehr', 'Send Request'),
        onClick: this.sendRequest,
        loading: this.state.loading,
        disabled: this.state.loading
      })));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return RequestDataModal;
}(React.Component);

var _default = withNotification(RequestDataModal);

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(logger, "logger", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/components/RequestData/RequestDataModal.js");
  reactHotLoader.register(DialogContent, "DialogContent", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/components/RequestData/RequestDataModal.js");
  reactHotLoader.register(RequestDataModal, "RequestDataModal", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/components/RequestData/RequestDataModal.js");
  reactHotLoader.register(_default, "default", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/components/RequestData/RequestDataModal.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();